<template>
  <a-modal
      class="cost-page"
      centered
      :title="`成本列表 (${model.name})`"
      :width="'55%'"
      :mask-closable="false"
      :visible="showCostForm"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
            <a-range-picker v-model="queryParam.date" valueFormat="YYYY-MM-DD" />
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="syncCost" type="primary" icon="plus" v-if="accessTo('syncCost') && !isFillCost">修复</a-button>
          <a-button @click="fillCost" type="primary" icon="plus" v-if="accessTo('fillCost') && isFillCost">录入成本</a-button>
          <a-button @click="resetSearch">重置</a-button>
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >
          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a href="javascript:;" @click="create(record)" v-if="accessTo('update')">编辑</a>
              <a-divider type="vertical"/>
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </a-table>
      </a-layout-content>
    </a-layout>

    <sync-cost-form
      v-if="showSyncCostForm"
      :showForm.sync="showSyncCostForm"
      :model="modelSync"
      @success="refresh"
    />

    <fill-cost-form
      v-if="showFillCostForm"
      :showForm.sync="showFillCostForm"
      :model="modelFill"
      @success="refresh"
    />

  </a-modal>

</template>

<style lang="less" scoped>
@import 'Cost';
</style>

<script>
import Cost from './Cost'

export default Cost
</script>

